export const gridColumns = `
  minmax(40px, 0.07fr)
  minmax(70px, 0.15fr)
  minmax(70px, 0.15fr)
  minmax(300px, 0.4fr)
  minmax(100px, 0.2fr)
  minmax(40px, 0.11fr)
  minmax(20px, 0.04fr);
`;
